<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'700px'"
    :classDialog="'createDialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        {{ dialogTitle }}
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="120px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Đơn vị" prop="deptId">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.deptId"
                placeholder="-"
                size="medium"
              >
                <el-option
                  v-for="item in departments"
                  :key="item.id"
                  :label="item.deptName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Tên" prop="name">
              <el-input
                v-model="form.name"
                placeholder="-"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Mã" prop="code">
              <el-input
                v-model="form.code"
                placeholder="-"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Cộng/trừ điểm" prop="type">
              <el-select
                class="input-border__bottom input-border__radius__0"
                v-model="form.type"
                placeholder="Cộng/trừ điểm"
                size="medium"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Loại" prop="scoreType">
              <el-select
                class="input-border__bottom input-border__radius__0"
                v-model="form.scoreType"
                placeholder="Chuyên môn/nguyên tắc"
                size="medium"
              >
                <el-option
                  v-for="item in scoreTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Điểm mặc định" prop="defaultScore">
              <el-input-number
                class="input-border__bottom input-border__radius__0"
                v-model="form.defaultScore"
                size="medium"
                placeholder="Điểm mặc định"
                :controls="false"
                :min="0"
                :step="0.1"
                :precision="1"
                :max="100"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                v-model="form.note"
                type="textarea"
                placeholder="-"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="5000"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12" v-if="!!id">
          <el-col :span="24">
            <el-form-item label="Trạng thái" prop="status">
              <el-checkbox
                @change="statusChanged"
                v-model="form.status"
              >
                {{ form.status ? "Hoạt động" : "Không hoạt động" }}
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #footer>
      <div class="flex-row form-button__action flex-row-space-between" v-if="!!id">
        <div class="flex__left">
          <el-button
            size="medium"
            class="addDocs color__white bg__red btn-none__border"
            @click="delete_"
          >
            <i class="far fa-trash-alt font-size__small"></i>
            &nbsp;Xóa
          </el-button>
          <el-button
            size="medium"
            type="success"
            class="addDocs  color__white bg__blue btn-none__border"
            @click="save"
          >
            <i class="far fa-check-circle font-size__small"></i>
            &nbsp;Lưu
          </el-button>
          <el-button
            type="info"
            size="medium"
            class="btn__cancel btn-none__border"
            @click="$emit('closeDialog')"
          >Bỏ qua
          </el-button>
        </div>
      </div>
      <div v-else class="flex-row form-button__action flex__left">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="save"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import CustomDialog from "../../common/custom-dialog";
import departmentService from "../../../services/departmentService";
import constants from "../../../constants";
import rankingUtils from "../../../services/rankingUtils";
import Vue from "vue";
import rankingReasonService from "../../../services/rankingReasonService";
import errorMessageFilter from "../../../filters/errorMessageFilter";

export default {
  name: "ranking-reason-dialog",
  props: ["isOpen", "id"],
  components: {CustomDialog},
  data() {
    return {
      dialogTitle: null,
      form: {
        deptId: null,
        code: null,
        name: null,
        type: null,
        scoreType: null,
        defaultScore: null,
        note: null,
        status: false
      },
      rules: {},
      departments: [],
      typeOptions: [],
      scoreTypeOptions: []
    };
  },

  created() {
    this.initDialogTitle();
    this.initOptions();
    this.initValidationRules();
    this.loadDepartments().then(() =>
      this.id ? this.initFormForEditing() : Promise.resolve()
    );
  },

  methods: {
    initFormForEditing() {
      return rankingReasonService.findById(this.id).then(response => {
        let rankingReason = response.data;
        this.form.deptId = rankingReason.deptId;
        this.form.code = rankingReason.code;
        this.form.name = rankingReason.name;
        this.form.type = rankingReason.type;
        this.form.scoreType = rankingReason.scoreType;
        this.form.defaultScore = rankingReason.defaultScore || 0;
        this.form.note = rankingReason.note;
        this.form.status = rankingReason.status === constants.STATUS_.ACTIVE;
      });
    },

    initDialogTitle() {
      this.dialogTitle = !this.id
        ? "Tạo mới danh mục lý do"
        : "Chi tiết danh mục lý do";
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };

      Vue.set(this.rules, "deptId", [defaultRequiredConstrains]);
      Vue.set(this.rules, "code", [defaultRequiredConstrains]);
      Vue.set(this.rules, "name", [defaultRequiredConstrains]);
      Vue.set(this.rules, "type", [defaultRequiredConstrains]);
      Vue.set(this.rules, "scoreType", [defaultRequiredConstrains]);
    },

    loadDepartments() {
      return departmentService
        .findAllCurrentAndIncludeSubDepts()
        .then(response => (this.departments = response.data));
    },

    initOptions() {
      this.typeOptions = [
        {
          value: constants.RANKING_REASON.TYPE.CONGDIEM,
          label: rankingUtils.getTypeLabel(
            constants.RANKING_REASON.TYPE.CONGDIEM
          )
        },
        {
          value: constants.RANKING_REASON.TYPE.TRUDIEM,
          label: rankingUtils.getTypeLabel(
            constants.RANKING_REASON.TYPE.TRUDIEM
          )
        }
      ];

      this.scoreTypeOptions = [
        {
          value: constants.RANKING_REASON.SCORE_TYPE.CHUYENMON,
          label: rankingUtils.getScoreTypeLabel(
            constants.RANKING_REASON.SCORE_TYPE.CHUYENMON
          )
        },
        {
          value: constants.RANKING_REASON.SCORE_TYPE.NGUYENTAC,
          label: rankingUtils.getScoreTypeLabel(
            constants.RANKING_REASON.SCORE_TYPE.NGUYENTAC
          )
        }
      ];
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) return;
          resolve();
        });
      });
    },

    save() {
      this.validateForm()
        .then(() => (this.id ? this.update_() : this.save_()))
        .then(rankingReason => {
          this.$message({
            message: this.id
              ? "Cập nhật lý do thành công"
              : "Tạo mới lý do thành công",
            type: "success"
          });
          this.id
            ? this.$emit("updateSuccess", {result: rankingReason})
            : this.$emit("insertSuccess", {result: rankingReason});
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    },

    convertToSubmitForm() {
      return {
        deptId: this.form.deptId,
        code: this.form.code,
        name: this.form.name,
        type: this.form.type,
        scoreType: this.form.scoreType,
        defaultScore: this.form.defaultScore,
        note: this.form.note
      };
    },

    save_() {
      return rankingReasonService
        .insert(this.convertToSubmitForm())
        .then(response => response.data);
    },

    delete_() {
      return this.$confirm(
        errorMessageFilter({
          errorCode: "rankingReason.delete.confirm"
        }),
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Bỏ qua",
          type: "warning"
        }
      )
        .then(() => rankingReasonService.delete(this.id))
        .then(response => {
          this.$message({
            message: "Xóa lý do thành công",
            type: "success"
          });
          this.$emit("deleteSuccess", {result: response.data});
        });
    },

    update_() {
      return rankingReasonService
        .update(this.id, this.convertToSubmitForm())
        .then(response => response.data);
    },

    statusChanged() {
      let newStatus = this.form.status;
      return new Promise(resolve => {
        this.$confirm(
          errorMessageFilter({
            errorCode: "rankingReason.changeStatus.confirm"
          }),
          {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Bỏ qua",
            type: "warning"
          }
        )
          .then(() => resolve())
          .catch(() => (this.form.status = !newStatus)); //rollback lại trạng thái cũ;
      })
        .then(() => rankingReasonService.changeStatus(this.id))
        .then(response => {
          this.$message({
            message: "Thay đổi trạng thái lý do thành công",
            type: "success"
          });
          this.$emit("updateSuccess", {result: response.data});
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/reason/ranking-reason-dialog.vue